<template>
  <div>
    <TopBar currentTitle="Ingredient Units">
      <b-button type="is-primary" size="is-small" icon-left="plus" @click="createNew">Add Unit</b-button>
    </TopBar>
    <div class="page-content">
    <h1 class="page-title">Ingredient Units</h1>
    <p class="page-subtitle mb-4">{{ units.length }} total</p>

    <!-- Table Card -->
    <div class="feeds-card">
      <div class="feeds-card-body compact">
        <b-table
          :data="units"
          :hoverable="true"
          @click="open">

          <b-table-column field="term" label="Unit" searchable sortable v-slot="props">
            <p class="has-text-weight-bold">{{ props.row.term }}</p>
          </b-table-column>

          <b-table-column field="plural" label="Plural" v-slot="props">
            {{ props.row.plural }}
          </b-table-column>

          <b-table-column field="created_at" width=100 label="Created" sortable centered v-slot="props">
            <span class="date-tag">{{ new Date(props.row.created_at).toLocaleDateString() }}</span>
          </b-table-column>

          <b-table-column field="delete" custom-key="actions" width=40 centered v-slot="props">
            <b-button type="is-danger" size="is-small" icon-right="delete" @click.stop="deleteItem(props.row)" />
          </b-table-column>
        </b-table>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import db from "@/firebase/db"
import TopBar from '@/components/layout/TopBar.vue'

const SCROLL_STATE_KEY = 'feeds_list_state_IngredientUnitListView'

export default {
  name: 'IngredientUnitListView',
  components: {
    TopBar
  },
  data() {
    return {
      units: [],
      scrollRestored: false
    }
  },
  watch: {
    units() {
      if (!this.scrollRestored) {
        this.scrollRestored = true
        this.$nextTick(() => {
          const savedState = sessionStorage.getItem(SCROLL_STATE_KEY)
          if (savedState) {
            const state = JSON.parse(savedState)
            if (state.scrollY > 0) {
              setTimeout(() => window.scrollTo(state.scrollX, state.scrollY), 50)
            }
          }
        })
      }
    }
  },
  firestore: {
    units: db.collection('ingredient_units').orderBy("created_at", "desc")
  },
  methods: {
    createNew() {
      db.collection("ingredient_units").add({
        created_at: Date.now(),
        term: null,
        plural: null
      })
      .then((docRef) => {
        this.$router.push({ name: 'IngredientUnitView', params: { id: docRef.id } })
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
    },
    open(unit) {
      this.$router.push({ name: 'IngredientUnitView', params: { id: unit.id } })
    },
    deleteItem(unit) {
      this.$buefy.dialog.confirm({
        title: 'Deleting ingredient unit',
        message: `Are you sure you want to delete ingredient unit: <b><i>"${unit.term}"</i></b>? <br /><br />This action cannot be undone.`,
        confirmText: 'Delete Unit',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          db.collection("ingredient_units").doc(unit.id)
          .delete()
          .then(() => {
            this.$buefy.toast.open({type: 'is-success', message: `Ingredient unit successfully deleted!`})
          }).catch((error) => {
            this.$buefy.toast.open({type: 'is-danger', message: `Error deleting ingredient unit: ${error}`})
          });
        }
      })
    }
  }
}
</script>

<style scoped>
.date-tag {
  font-size: 12px;
  color: var(--text-secondary);
}
</style>
